import request from '../utils/request'

export function getBannerScenes() {
  return request({
    url: '/api/admin/ops/banners/scenes',
    method: 'get'
  })
}

export function getBannerItems(params) {
  return request({
    url: '/api/admin/ops/banners',
    method: 'get',
    params
  })
}

export function createBannerItem(data) {
  return request({
    url: '/api/admin/ops/banners',
    method: 'post',
    data
  })
}

export function updateBannerItem(id, data) {
  return request({
    url: `/api/admin/ops/banners/${id}`,
    method: 'put',
    data
  })
}

export function enableBannerItem(id) {
  return request({
    url: `/api/admin/ops/banners/${id}/enable`,
    method: 'post'
  })
}

export function disableBannerItem(id) {
  return request({
    url: `/api/admin/ops/banners/${id}/disable`,
    method: 'post'
  })
}
